<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
            <!-- <router-link to="/inventaires/liste-inventaires" class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link> -->
          </div>
          <table class="table" v-if="inventaire">
            <tbody>
              <tr>
                <th>Référence</th>
                <td>{{ inventaire.refInventaire }}</td>
                <th>Période</th>
                <td>De {{ format_Date(inventaire.dateDebut) }} à {{ format_Date(inventaire.dateFin) }}</td>
              </tr>
              <tr>
                <th>Type inventaire </th>
                <td>{{ inventaire.typeInventaire }}</td>
                <th>Etat</th>
                <td v-if="inventaire.estCloturer == true"><span class="badge text-success">{{ "Cloturer" }}</span></td>
                <td v-else><span class="badge text-danger">{{ "En cours" }}</span></td>
              </tr>
              <tr>
                <th colspan="2">Motif</th>
                <td colspan="2">{{ inventaire.motif }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 project-list">
      <div class="card">
        <div class="row">
          <div class="col-md-6">
            <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
              <li class="nav-item"><a class="nav-link active" id="profile-top-tab" data-bs-toggle="tab" href="#top-equipe"
                  role="tab" aria-controls="top-equipe" aria-selected="false"><vue-feather
                    type="info"></vue-feather>Equipe</a>
              </li>
              <li class="nav-item"><a class="nav-link" id="profile-top-tab" data-bs-toggle="tab" href="#top-produits"
                  role="tab" aria-controls="top-produits" aria-selected="false"><vue-feather
                    type="info"></vue-feather>Produits</a>
              </li>
              <li class="nav-item"><a class="nav-link" id="contact-top-tab" data-bs-toggle="tab"
                  href="#top-inventaire-partielle" role="tab" aria-controls="top-inventaire-partielle"
                  aria-selected="false"><vue-feather type="check-circle"></vue-feather>Inventaire Partielle</a>
              </li>
            </ul>
          </div>
          <div class="col-md-6"  v-if="checkPermission('EditInventaireEtat')">
            <div class="form-group mb-0 me-0"></div>
            <a class="btn btn-danger" @click="cloturer()" v-if="inventaire?.estCloturer == false" type="button">
              <i data-feather="plus-square"> </i>Clôturer
            </a>
          </div>
        </div>
      </div>
    </div>
    <Card3 colClass="col-sm-12">
      <div class="tab-content" id="top-tabContent">
        <div class="tab-pane fade active" id="top-equipe" role="tabpanel" aria-labelledby="top-equipe-tab">
          <div class="row">
            <div class="col">
                  <table class="table display">
                    <thead>
                      <tr>
                        <th> <span class="f-light f-w-600">Nom</span></th>
                        <th> <span class="f-light f-w-600">Prénom</span></th>
                        <th> <span class="f-light f-w-600">Role</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="product-removes" v-for="(row, index) in equipes" :key="index">
                        <td>
                          <div class="product-names">
                            <p>{{ row.user?.nom }}</p>
                          </div>
                        </td>
                        <td>
                          <p class="f-light">{{ row.user?.prenom }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.role?.nom }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                <!--</div>
              </div>-->
            </div>
          </div>
        </div>
        <div class="tab-pane" id="top-produits" role="tabpanel" aria-labelledby="top-produits-tab">
          <div class="row">
            <div class="col">
              <!--<div class="card mb-25 border-0 rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
                  <div
                    class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
                    <h4 class="position-relative text-black fw-bold mb-10">Produit magasin</h4>
                  </div>-->
                  <table class="table display" id="project-status">
                    <thead>
                      <tr>
                        <th> <span class="f-light f-w-600">Produit</span></th>
                        <th> <span class="f-light f-w-600">Qté Fiche</span></th>
                        <th> <span class="f-light f-w-600">Qté Log </span></th>
                        <th> <span class="f-light f-w-600">Qté Phy</span></th>
                        <th> <span class="f-light f-w-600">Qte Avariée</span></th>
                        <th> <span class="f-light f-w-600">Ecart Log</span></th>
                        <th> <span class="f-light f-w-600">Ecart Phy</span></th>
                        <th> <span class="f-light f-w-600">Qté ApI</span></th>
                        <th> <span class="f-light f-w-600">Action</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="product-removes" v-for="(row, index) in inventaiprocondimags" :key="index">
                        <td>
                          <div class="product-names">
                            <div class="light-product-box">
                              <img class="img-fluid" :src="getUrlApiForProductFiles()" alt="imageFichier">
                            </div>
                            <p>{{ row.nomProd }}</p>
                          </div>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qteFiche }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qteLogique }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qtePhysique }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qteAvariee }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qtePhysique - row.qteLogique }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qtePhysique - row.qteFiche }}</p>
                        </td>
                        <td>
                          <p class="f-light">{{ row.qteTotalApresMouv }}</p>
                        </td>
                        <td>
                          <div class="product-action">
                            <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                              data-bs-toggle="modal" data-bs-target="#ModalModifierProdCondMagInv" @click="modifier(row)">
                              <svg>
                                <use href="@/assets/svg/icon-sprite.svg#pencil"></use>
                              </svg>
                            </a>

                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                <!--</div>
              </div>-->
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="top-inventaire-partielle" role="tabpanel"
          aria-labelledby="top-inventaire-partielle-tab">
          <!--<div class="row">
            <div class="col">
              <div class="card mb-25 border-0 rounded-0">-->
                <!--<div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">-->
                  <!--<div
                    class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
                    <h4 class="position-relative text-black fw-bold mb-10">Inventaires partielles</h4>
                  </div>-->
                  <div class="row">
                    <div class="col-xxl-4 col-lg-4 col-md-6" v-for="(inventaire, index) in inventairePartielles"
                      :key="index">
                      <div class="project-box"
                        :class="inventaire.estCloturer == true ? 'b-light1-success' : 'b-light1-primary'">
                        <span class="badge badge-primary">
                          {{ inventaire.magasin.nomMagasin }}
                        </span>
                        <h5 class="f-w-500 mt-1">{{ inventaire.typeInventaire + ' N° : ' + inventaire.refInventaire }}
                        </h5>
                        <div class="d-flex"><img class="img-20 me-1 rounded-circle" :src='getImages("user/3.jpg")'
                            alt="" data-original-title="" title="">
                          <div class="flex-grow-1">
                            <p>Du {{ format_Date(inventaire.dateDebut) }} au {{ format_Date(inventaire.dateFin) }}</p>
                          </div>
                        </div>
                        <p>{{ "Détails" }}</p>
                        <div class="row details">
                          <div class="col-6"><span>Nmbre Produits </span></div>
                          <div class="col-6 font-primary">{{ inventaire.inventaiprocondimags.length }} </div>
                          <!--<div class="col-6"> <span>Resolved</span></div>
                          <div class="col-6 font-primary">{{ "30" }}</div>
                          <div class="col-6"> <span>Comment</span></div>
                          <div class="col-6 font-primary">{{ "20" }}</div>-->
                        </div>
                        <hr />
                        <div class="customers">
                          <ul>
                            <li class="d-inline-block" v-for="(equipe, eqIn) in inventaire.equipes" :key="eqIn"><img
                                class="img-30 rounded-circle" :src='getImages("user/1.jpg")' alt=""
                                :data-original-title="equipe.user?.nom + ' ' + equipe.user?.prenom"
                                :title="equipe.user?.nom + ' ' + equipe.user?.prenom">
                            </li>
                            <li class="d-inline-block ms-2">
                              <p class="f-12"><router-link class="dropdown-item d-flex align-items-center"
                                  :to="{ name: 'DetailInventairePage', params: { id: inventaire.id } }"> Aller vers
                                  l'inventaire</router-link></p>
                            </li>
                          </ul>
                        </div>
                        <div class="project-status mt-4">
                          <div class="d-flex mb-0">
                            <p>{{ inventaire.estCloturer == true ? "100" : "50" }}% </p>
                            <div class="flex-grow-1 text-end"><span>Etat</span></div>
                          </div>
                          <div class="progress" style="height: 5px">
                            <div class="progress-bar-animated"
                              :class="(inventaire.estCloturer == true ? 'bg-success' : 'bg-warning')" role="progressbar"
                              :style="{ 'width': (inventaire.estCloturer == true ? '100' : '50') + '%' }"
                              aria-valuenow="10" :aria-valuemin="(inventaire.estCloturer == true ? 10 : 0)"
                              aria-valuemax="100">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <!--</div>-->
              <!--</div>
            </div>
          </div>-->
        </div>
      </div>
    </Card3>
  </div>

  <ModalModifierProdCondMagInv :item="element" @close="rafraichir" ref="editModalModifierProdCondMagInv" />
</template>

<script lang="ts">
import { defineComponent, onMounted, defineAsyncComponent, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Produit } from "@/models/Produit";
import { error, format_Date, showModal,success, format_date, getUrlApiForProductFiles } from "@/utils/utils";
import ModalModifierProdCondMagInv from "./ModalModifierProdCondMagInv.vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { getImages } from "@/composables/common/getImages"
import axios from "axios";
import JwtService from "@/services/JwtService";
const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))


export default defineComponent({
  name: "DetailInventaire",
  components: {
    Card3,
    ModalModifierProdCondMagInv
  },
  setup: () => {
    const route = useRoute();
    const inventaire = ref<any | null>(null);
    const inventaiprocondimags = ref([]);
    const equipes = ref([]);
    const inventairePartielles = ref([]);

    const getInventaire = async (id: string) => {
      try {
        const reponse = await ApiService.get(`/inventaires/${id}`);
        inventaire.value = reponse.data.data;
        inventaiprocondimags.value = inventaire.value.inventaiprocondimags;
        equipes.value = inventaire.value.equipes;
        inventairePartielles.value = inventaire.value.inventairePartielles;
        console.log("HJJJJJJJJJJJJJ ===> ", inventaire.value);
        console.log("99999999999999 ===> ", inventaiprocondimags.value);
      } catch (response) {
        error(response.message);
      }
    }

    const rafraichir = async ()=>{
      if(identifiant.value){
        await getInventaire(identifiant.value);
      }
    }
    const element = ref<any | null>(null);

    const modifier = (valeur: any) => {
      element.value = valeur;
    };
    const identifiant = ref();
    onMounted(async () => {
      const id = route.params.id as string;
      identifiant.value = id;
      await getInventaire(id);
      console.log("FDDFDVHGVHJN ====>", id)
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

const checkPermission = (name) => {
  return privileges.value.includes(name);
}

    const cloturer = async()=>{
      Swal.fire({
        text: "Vous êtes sur le point de cloturer un inventaire. Etes-vous sûr ?",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Cloturer",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      }).then(async(result) => {
        if (result.isConfirmed) {
          try {
            console.log("inventaire.value.id == > ", inventaire.value.id)
              await axios.put(`/inventaires/${inventaire.value.id}/cloturer`);
              await getInventaire(inventaire.value.id)
              success("Inventaire cloturé avec succès");
            } catch (response) {
              error(response.message);
          }
        }else{
          error("Vous avez annulé la cloture");
        }
        
      })
    }


    return {
      inventaire,
      checkPermission,
      getInventaire,
      format_Date,
      inventaiprocondimags,
      getUrlApiForProductFiles,
      inventairePartielles,
      equipes,
      getImages,
      format_date,
      modifier,
      element,
      cloturer,
      rafraichir
    };
  },
});
</script>